import React, { memo } from "react";
import cx from "classnames";
import { AlertFill, CloseLine, ErrorWarningFill, InformationFill } from "../IconV2/react";
import CheckboxCircleFill from "../IconV2/react/CheckboxCircleFill";
import { css } from "@linaria/core";
import { colors, spacings } from "../Theme";
import Text from "../Text";
import Button from "../Button";

function SectionMessage_({
  state,
  title,
  content,
  actionLabel,
  action,
  close,
}: {
  state: "info" | "warning" | "success" | "error";
  title?: string;
  content: string;
  actionLabel?: string;
  action?: () => void;
  close?: () => void;
}) {
  return (
    <div className={cx(sectionMessage, state)}>
      {state === "info" && <InformationFill size="m" />}
      {state === "warning" && <AlertFill size="m" />}
      {state === "success" && <CheckboxCircleFill size="m" />}
      {state === "error" && <ErrorWarningFill size="m" />}
      {title && (
        <Text type="body1SemiBold" className={sectionMessageTitle}>
          {title}
        </Text>
      )}
      <Text type="body1" className={sectionMessageContent}>
        {content}
      </Text>
      {action && (
        <Button variant="link" onClick={() => action()} className={sectionMessageAction}>
          {actionLabel}
        </Button>
      )}
      {close && (
        <button className={sectionMessageCloseButton} onClick={close}>
          <CloseLine size="m" />
        </button>
      )}
    </div>
  );
}
export const SectionMessage = memo(SectionMessage_);

const sectionMessage = css`
  background-color: var(--accent);
  border: 1px solid var(--color);
  border-radius: 4px;
  display: grid;
  column-gap: ${spacings.xs};
  row-gap: ${spacings.xxs};
  grid-template-columns: max-content 1fr max-content;
  padding: ${spacings.m};

  > svg:first-child {
    align-self: start;
    fill: var(--color);
    grid-column: 1 / span 1;
    margin-top: 1px;
  }

  &.info {
    --color: ${colors.darkNitrogen600};
    --accent: ${colors.darkNitrogen50};
  }
  &.warning {
    --color: ${colors.phosphorus500};
    --accent: ${colors.phosphorus50};
  }
  &.success {
    --color: ${colors.chlorine700};
    --accent: ${colors.chlorine50};
  }
  &.error {
    --color: ${colors.oxygen500};
    --accent: ${colors.oxygen50};
  }
`;

const sectionMessageTitle = css`
  color: ${colors.carbon900};
  word-break: break-word;
  grid-column: 2;
`;

const sectionMessageContent = css`
  color: ${colors.carbon800};
  word-break: break-word;
  grid-column: 2;
`;

const sectionMessageAction = css`
  width: max-content;
  grid-column: 2;
`;

const sectionMessageCloseButton = css`
  align-self: start;
  all: unset;
  cursor: pointer;
  height: max-content;
  grid-column: 3;
  grid-row: 1 / span 2;

  svg {
    fill: ${colors.titanium500};
    display: block;
  }

  &:hover svg {
    fill: ${colors.titanium800};
  }
`;
